import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";
import { FlexColumn, FlexRow } from "../../../../../Common/Styles";

export const ContentUnavailable = () => {
  const { typography } = useTheme();

  return (
    <Container>
      <Border>
        <Content $gapInPx={8}>
          <Title>
            <Components.Icon type="AlertTriangle" size="16px" />
            <Components.Text
              text="Content is unavailable"
              style={{ tokenStyle: typography.Heading.S }}
              fontWeight="font-weight-semibold"
            />
          </Title>
          <Components.Text
            style={{ tokenStyle: typography.Body.M }}
            text={
              "Looks like this post was deleted or the original poster updated their privacy settings."
            }
          />
        </Content>
      </Border>
    </Container>
  );
};

const Container = styled.div(
  ({ theme }) => `
  border-radius: ${theme.radius["radius-m"].value}rem;
  padding: ${theme.spacing["spacing-2"].value}rem ${theme.spacing["spacing-4"].value}rem;
`
);
const Border = styled.div(
  ({ theme }) => `
  background: linear-gradient(
    124.84deg,
    ${theme.Color.elevation.surface["surface-secondary"].value},
    ${theme.Color.background.neutral.subtlest.default.value}
  );
  border-radius: ${theme.radius["radius-m"].value}rem;
  padding: ${theme.spacing["spacing-2"].value}rem;
`
);
const Content = styled(FlexColumn)(
  ({ theme }) =>
    `background: ${theme.Color.background.neutral.subtle.default.value};
  border-radius: ${theme.radius["radius-m"].value}rem;
  padding: ${theme.spacing["spacing-4"].value}rem;`
);
const Title = styled(FlexRow)`
  align-items: center;
`;
